import { useState } from "react"
import Button from "../ui/Button"

const PRESETS = [
    { label: 'Custom', width: null, height: null },
    { label: '1920 × 1080 (16:9)', width: 1920, height: 1080 },
    { label: '1280 × 720 (16:9)', width: 1280, height: 720 },
    { label: '1024 × 1024 (1:1)', width: 1024, height: 1024 },
    { label: '1080 × 1920 (9:16)', width: 1080, height: 1920 },
    { label: '720 × 1280 (9:16)', width: 720, height: 1280 },
]

function findPresetIndex(w, h) {
    const idx = PRESETS.findIndex(p => p.width === w && p.height === h)
    return idx > 0 ? idx : 0
}

export default function ResolutionModal({ onClose, title = 'Resolution', width: initialWidth = 1920, height: initialHeight = 1080 }) {
    const [presetIndex, setPresetIndex] = useState(() => findPresetIndex(initialWidth, initialHeight))
    const [width, setWidth] = useState(initialWidth)
    const [height, setHeight] = useState(initialHeight)

    const handlePresetChange = (e) => {
        const idx = parseInt(e.target.value)
        setPresetIndex(idx)
        const preset = PRESETS[idx]
        if (preset.width !== null && preset.height !== null) {
            setWidth(preset.width)
            setHeight(preset.height)
        }
    }

    const handleWidthChange = (e) => {
        const val = parseInt(e.target.value) || 0
        setWidth(val)
        setPresetIndex(findPresetIndex(val, height))
    }

    const handleHeightChange = (e) => {
        const val = parseInt(e.target.value) || 0
        setHeight(val)
        setPresetIndex(findPresetIndex(width, val))
    }

    const handleDone = () => {
        onClose({ width, height })
    }

    return (
        <div className='w-full max-w-[400px] rounded-md flex flex-col bg-background border'>
            <div className='flex justify-between py-2 px-4 border-b items-center'>
                <span className='text-secondary-foreground text-lg font-bold'>{title || 'Resolution'}</span>
            </div>

            <div className='flex flex-col gap-4 p-4'>
                {/* Preset dropdown */}
                <div className='flex flex-col gap-1'>
                    <label className='text-secondary-foreground text-xs'>Preset</label>
                    <select
                        className='text-sm bg-secondary border rounded-md px-2 py-1.5 text-secondary-foreground outline-none cursor-pointer'
                        value={presetIndex}
                        onChange={handlePresetChange}
                    >
                        {PRESETS.map((preset, idx) => (
                            <option key={idx} value={idx}>{preset.label}</option>
                        ))}
                    </select>
                </div>

                {/* Width & Height inputs */}
                <div className='flex gap-4'>
                    <div className='flex flex-col gap-1 flex-1'>
                        <label className='text-secondary-foreground text-xs'>Width</label>
                        <input
                            type='number'
                            className='text-sm bg-secondary border rounded-md px-2 py-1.5 text-secondary-foreground outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none'
                            value={width}
                            min={1}
                            onChange={handleWidthChange}
                        />
                    </div>
                    <div className='flex flex-col gap-1 flex-1'>
                        <label className='text-secondary-foreground text-xs'>Height</label>
                        <input
                            type='number'
                            className='text-sm bg-secondary border rounded-md px-2 py-1.5 text-secondary-foreground outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none'
                            value={height}
                            min={1}
                            onChange={handleHeightChange}
                        />
                    </div>
                </div>
            </div>

            <div className='flex justify-end p-2 gap-4'>
                <Button type='danger-ghost' className='min-w-20' onClick={() => onClose(null)}>Cancel</Button>
                <Button type='primary' className='min-w-20' onClick={handleDone}>Done</Button>
            </div>
        </div>
    )
}
